<script lang="ts">
	import Icon from '$shared/icons/Icon.svelte';

	export let image: string | null = null;
  export let name = '';

	const hasImage = !!image;
</script>

<div class="expert-lockup">
	{#if hasImage}
    <div class="avatar-container">
      <img src={image} alt={name} />
    </div>
  {:else}
    <div class="avatar-container avatar-container--icon">
      <Icon icon="UsersRound" size="medium" />
    </div>
  {/if}

  <span class="expert-name">{name}</span>
</div>

<style>
	.expert-lockup {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.5rem;
  }
  .avatar-container {
    width: 3rem;
    height: 3rem;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: theme('borderRadius.3xl');
    overflow: hidden;
  }
  .avatar-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .avatar-container--icon {
    background-color: #f5f5f5;
  }
  .expert-name {
    flex-shrink: 0;
  }
</style>